import { signOut as firebaseSignOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import API, {
  GetQuickBooksAdminSignoutPath,
  GetPartnerSignoutPathForApi,
  GetEmployeeUserSignoutPathForApi,
} from '../Util/api';
import {
  GetSignInPath,
} from '../Util/PathHelper';

export const GetUserSignOutPromise = () => {
  return API.get(GetQuickBooksAdminSignoutPath());
}

export const GetPartnerSignOutPromise = () => {
  return API.get(GetPartnerSignoutPathForApi());
}

export const GetEmployeeUserSignOutPromise = () => {
  return API.get(GetEmployeeUserSignoutPathForApi());
}

export const SignOut = props => {
    // Sign out of Firebase first, then server session
    firebaseSignOut(auth).catch(() => {});
    GetUserSignOutPromise()
      .catch(err => {
        // Ignore
      })
      .finally(props.history.push(GetSignInPath()));
}